import React from 'react';
// Import necessary icons from lucide-react
import {
  CalendarDays,
  Scissors, // Used for 'Essensplanung' (Meal Planning)
  ShoppingCart,
  ListChecks, // Used for 'Checklisten-Manager'
  Users, // Used for 'Familien-Workspaces'
  Sparkle, // Used for 'KI-Assistent' (AI Assistant)
} from 'lucide-react';

// --- Feature Data (for cleaner code) ---
const features = [
  {
    title: 'Wochenübersicht',
    description: 'Alle Termine, Ereignisse und Aufgaben der Familie auf einen Blick. Immer wissen, was ansteht.',
    icon: CalendarDays,
    iconColor: '#5a6268', // Default text color
    iconBg: '#e6f0ff', // Light blue background
  },
  {
    title: 'Essensplanung',
    description: 'Plant gemeinsam die Mahlzeiten der Woche. Keine Frage mehr: "Was essen wir heute?"',
    icon: Scissors,
    iconColor: '#5a6268',
    iconBg: '#ffe6f0', // Light pink background
  },
  {
    title: 'Smarte Einkaufsliste',
    description: 'Automatisch generierte Einkaufslisten basierend auf eurem Essensplan. KI-gestützt und immer aktuell.',
    icon: ShoppingCart,
    iconColor: '#5a6268',
    iconBg: '#e6fff0', // Light green background
  },
  {
    title: 'Checklisten-Manager',
    description: 'Erstellt Checklisten für Urlaub, Schule, Haushalt – und verwendet sie immer wieder.',
    icon: ListChecks,
    iconColor: '#5a6268',
    iconBg: '#f0e6ff', // Light purple background
  },
  {
    title: 'Familien-Workspaces',
    description: 'Teilt Workspaces mit allen Familienmitgliedern. Jeder hat Zutritt, überall und jederzeit.',
    icon: Users,
    iconColor: '#5a6268',
    iconBg: '#fff0e6', // Light orange background
  },
  {
    title: 'KI-Assistent',
    description: 'Euer intelligenter Helfer im Hintergrund: erkennt Konflikte, gibt Empfehlungen und delegiert Aufgaben.',
    icon: Sparkle,
    iconColor: '#5a6268',
    iconBg: '#e6f0ff', // Light blue background (matching the first one)
  },
];

// --- Feature Card Component ---
const FeatureCard = ({ title, description, Icon, iconBg }) => {
  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div className="card h-100 feature-card p-3 border-0 shadow-sm">
        <div
          className="d-flex justify-content-center align-items-center mb-3 rounded-3"
          style={{ width: '40px', height: '40px', backgroundColor: iconBg }}
        >
          {/* Icon from Lucide-React */}
          <Icon size={20} className="text-primary" style={{ color: '#0d6efd' }} />
        </div>
        <h5 className="fw-bold mb-2">{title}</h5>
        <p className="text-secondary small">{description}</p>
      </div>
    </div>
  );
};

// --- Main Component ---
const FeatureSection = () => {
  return (
    <section id="features" className="py-5" style={{ backgroundColor: 'white' }}>
      <div className="container">
        {/* Header Section */}
        <div className="text-center mb-5">
          <h2 className="fw-bolder">Alles für euren Familienalltag</h2>
          <p className="text-muted lead">
            Von der Wochenplanung bis zur Einkaufsliste – WeekerAI vereint alle wichtigen Funktionen in einer App.
          </p>
        </div>

        {/* Feature Grid Section */}
        <div className="row">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              title={feature.title}
              description={feature.description}
              Icon={feature.icon}
              iconBg={feature.iconBg}
            />
          ))}
        </div>
      </div>

      {/* NOTE: The image shows a 'container fw bold my 3' text at the top left of the grid. 
        I've included the visual equivalent of the grid structure. 
        If you need that specific text, you can add it like this:
        <div className="container fw-bold my-3 text-start">container fw bold my 3</div>
      */}
    </section>
  );
};

export default FeatureSection;